import { SvgIcon } from "@mui/material";
import React from "react";

function LogoutIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M15.9866 13.4004L18.3332 11.0537L15.9866 8.70703"
        stroke="#ED3237"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.94678 11.0547H18.2693"
        stroke="#ED3237"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7801 18.3346C6.72844 18.3346 3.44678 15.5846 3.44678 11.0013C3.44678 6.41797 6.72844 3.66797 10.7801 3.66797"
        stroke="#ED3237"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default LogoutIcon;
